<script lang="ts">
  import { css } from '@agapi/ui/panda/css';

  export interface DynamicIconProps {
    name: 'award' | 'chat' | 'bulb' | 'star' | 'heart' | 'shield' | 'check' | 'truck' | 'check-circle' | 'leaf' | 'flower' | 'tree' | 'sun' | 'moon' | 'cloud' | 'phone';
    size?: number;
    weight?: 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';
  }

  const iconMap = {
    award: () => import('phosphor-svelte/lib/Medal').then(m => m.default),
    chat: () => import('phosphor-svelte/lib/ChatCircle').then(m => m.default),
    bulb: () => import('phosphor-svelte/lib/Lightbulb').then(m => m.default),
    star: () => import('phosphor-svelte/lib/Star').then(m => m.default),
    heart: () => import('phosphor-svelte/lib/Heart').then(m => m.default),
    shield: () => import('phosphor-svelte/lib/Shield').then(m => m.default),
    check: () => import('phosphor-svelte/lib/Check').then(m => m.default),
    'check-circle': () => import('phosphor-svelte/lib/CheckCircle').then(m => m.default),
    leaf: () => import('phosphor-svelte/lib/Leaf').then(m => m.default),
    flower: () => import('phosphor-svelte/lib/Flower').then(m => m.default),
    tree: () => import('phosphor-svelte/lib/Tree').then(m => m.default),
    sun: () => import('phosphor-svelte/lib/Sun').then(m => m.default),
    moon: () => import('phosphor-svelte/lib/Moon').then(m => m.default),
    cloud: () => import('phosphor-svelte/lib/Cloud').then(m => m.default),
    phone: () => import('phosphor-svelte/lib/Phone').then(m => m.default),
    truck: () => import('phosphor-svelte/lib/Truck').then(m => m.default)
  };

  const { name, size = undefined, weight = 'bold' }: DynamicIconProps = $props();

  let Icon: any = $state(undefined);

  $effect(() => {
    if (name in iconMap) {
      iconMap[name]().then(component => {
        Icon = component;
      });
    }
  });
</script>

{#if Icon}
  <Icon {weight} size={size} />
{:else}
  <span class={css({ display: 'inline-block', width: '1em', height: '1em' })}></span>
{/if}
